const DEFAULT_STORAGE_KEY = 'bema.selectedCompanyId';

function toCompanyId(value) {
  const parsed = Number.parseInt(value, 10);

  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

function toCompanyFilter(value) {
  const parsed = Number.parseInt(value, 10);

  return Number.isInteger(parsed) && (parsed > 0 || parsed === 0 || parsed === -10) ? parsed : null;
}

function getAvailableCompanies(config) {
  if (!config || !Array.isArray(config.companies)) {
    return [];
  }

  return config.companies
    .map((company) => ({ ...company, id: toCompanyId(company.id) }))
    .filter((company) => company.id !== null);
}

function resolveSelectedCompanyId(config, storage) {
  const companies = getAvailableCompanies(config);
  if (companies.length === 0) {
    return null;
  }

  const configuredCompanyId = toCompanyFilter(config.selectedCompanyId);
  if (configuredCompanyId === 0 || configuredCompanyId === -10) {
    storage.setItem(config.storageKey || DEFAULT_STORAGE_KEY, String(configuredCompanyId));

    return configuredCompanyId;
  }

  if (configuredCompanyId && companies.some((company) => company.id === configuredCompanyId)) {
    storage.setItem(config.storageKey || DEFAULT_STORAGE_KEY, String(configuredCompanyId));

    return configuredCompanyId;
  }

  if (companies.length === 1) {
    const defaultCompanyId = companies[0].id;
    storage.setItem(config.storageKey || DEFAULT_STORAGE_KEY, String(defaultCompanyId));

    return defaultCompanyId;
  }

  storage.removeItem(config.storageKey || DEFAULT_STORAGE_KEY);

  return null;
}

function withSelectedCompany(url, companyId) {
  if (companyId === null) {
    return url;
  }

  const parsedUrl = new URL(url, window.location.origin);
  parsedUrl.searchParams.set('company', String(companyId));

  return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
}

function syncCompanySelector(selector, storageKey) {
  selector.addEventListener('change', () => {
    const companyFilter = toCompanyFilter(selector.value);
    if (companyFilter !== null) {
      window.localStorage.setItem(storageKey, String(companyFilter));
    }
  });
}

function syncCompanyAwareLinks(companyId) {
  document.querySelectorAll('a[data-bema-company-link]').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
      return;
    }

    link.setAttribute('href', withSelectedCompany(href, companyId));
  });
}

function syncCompanyAwareForms(companyId) {
  if (companyId === null) {
    return;
  }

  document.querySelectorAll('form[data-bema-company-form]').forEach((form) => {
    let input = form.querySelector('input[name="company"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'company';
      form.appendChild(input);
    }

    input.value = String(companyId);
  });
}

function syncCompanySelectorForms(companyId, storageKey) {
  document.querySelectorAll('[data-bema-company-selector]').forEach((selector) => {
    if (companyId !== null && toCompanyFilter(selector.value) === null) {
      selector.value = String(companyId);
    }

    syncCompanySelector(selector, storageKey);
  });
}

function initCompanySelection() {
  const config = window.bemaCompanySelection;
  if (!config || !window.localStorage) {
    return;
  }

  const storageKey = config.storageKey || DEFAULT_STORAGE_KEY;
  const companyId = resolveSelectedCompanyId({ ...config, storageKey }, window.localStorage);

  syncCompanySelectorForms(companyId, storageKey);
  syncCompanyAwareLinks(companyId);
  syncCompanyAwareForms(companyId);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCompanySelection);
} else {
  initCompanySelection();
}





